setTimeout(function() {
  const alertElement = document.querySelector('.alert');
  if (alertElement) {
    alertElement.classList.add('fade-out');
    // Allow transition (CSS) to complete before removing
    setTimeout(function() {
      alertElement.remove();
    }, 500);
  }
}, 5000);